{
  "actionbar.actions": "Akce",
  "actionbar.actionsAvailable": "Dostupné akce.",
  "actionbar.clearSelection": "Vymazat výběr",
  "actionbar.selected": "Vybráno: { count }",
  "actionbar.selectedAll": "Vybráno vše",
  "button.pending": "čeká na vyřízení",
  "calendar.invalidSelection": "{selectedCount, plural, one {Vybrané datum není} other {Vybraná data nejsou}} k dispozici.",
  "contextualhelp.help": "Nápověda",
  "contextualhelp.info": "Informace",
  "datepicker.endTime": "Konečný čas",
  "datepicker.startTime": "Počáteční čas",
  "datepicker.time": "Čas",
  "dialog.alert": "Výstraha",
  "dialog.dismiss": "Odstranit",
  "dropzone.replaceMessage": "Přetáhněte soubor k nahrazení",
  "inlinealert.informative": "Informace",
  "inlinealert.negative": "Chyba",
  "inlinealert.notice": "Varování",
  "inlinealert.positive": "Úspěch",
  "label.(optional)": "(volitelně)",
  "label.(required)": "(požadováno)",
  "menu.moreActions": "Další akce",
  "picker.placeholder": "Vybrat…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Načítání...",
  "table.loadingMore": "Načítání dalších...",
  "table.resizeColumn": "Změnit velikost sloupce",
  "table.sortAscending": "Seřadit vzestupně",
  "table.sortDescending": "Seřadit sestupně",
  "tag.actions": "Akce",
  "tag.hideButtonLabel": "Zobrazit méně",
  "tag.noTags": "Žádný",
  "tag.showAllButtonLabel": "Zobrazit vše ({tagCount, number})",
  "breadcrumbs.more": "Další položky",
  "combobox.noResults": "Žádné výsledky",
  "notificationbadge.indicatorOnly": "Nová aktivita",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}